/* Give every heading in page and post content a stable id, so links can point
   at a section of a page - /about/#how-we-test, for instance.
   Ghost does not add these itself, and an anchor that matches nothing simply
   lands at the top of the page with no sign anything went wrong.

   The id is the heading's text, lowercased, with runs of anything that is not
   a letter or digit collapsed to a single hyphen. A heading that already has
   an id keeps it, and a duplicate gets a numeric suffix rather than silently
   shadowing the first one. */
(function () {
    var content = document.querySelector('.gh-content');
    if (!content) { return; }

    var used = Object.create(null);

    content.querySelectorAll('h2, h3, h4').forEach(function (heading) {
        if (heading.id) { used[heading.id] = true; return; }

        var base = (heading.textContent || '')
            .toLowerCase()
            .replace(/['’]/g, '')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');

        if (!base) { return; }

        var id = base;
        var n = 2;
        while (used[id]) { id = base + '-' + n; n += 1; }

        used[id] = true;
        heading.id = id;
    });

    /* If the page was opened with a hash that only exists now, jump to it. */
    if (window.location.hash) {
        var target = document.getElementById(window.location.hash.slice(1));
        if (target) { target.scrollIntoView(); }
    }
}());
